import {
  createPromiseAction,
  rejectPromiseAction,
  resolvePromiseAction,
} from 'redux-saga-promise-actions'
import { call, put, takeEvery } from 'redux-saga/effects'
import { profileCompanyLogoAPI } from '../../../../api'
import { userData } from 'features/user/store'
import {
  PROFILE_EMPLOYER_COMPANY_LOGO_UPLOAD_REQUEST,
  PROFILE_EMPLOYER_COMPANY_LOGO_UPLOAD_SUCCESS,
  PROFILE_EMPLOYER_COMPANY_LOGO_UPLOAD_FAILED,
} from './actionTypes'

export const profileEmployerCompanyLogoUploadPA = createPromiseAction(
  PROFILE_EMPLOYER_COMPANY_LOGO_UPLOAD_REQUEST,
  PROFILE_EMPLOYER_COMPANY_LOGO_UPLOAD_SUCCESS,
  PROFILE_EMPLOYER_COMPANY_LOGO_UPLOAD_FAILED
)()

function* upload(action) {
  try {
    const response = yield call(profileCompanyLogoAPI.uploadLogo, action.payload)
    const { data } = response

    yield put(profileEmployerCompanyLogoUploadPA.success({}))

    yield put(userData.updateEmployerProfile({ company_logo: data?.data }))

    resolvePromiseAction(action, {})
  } catch (error) {
    if (!error.response) {
      throw error
    }
    rejectPromiseAction(action, error.response.data)
  }
}

export function* uploadSaga() {
  yield takeEvery(profileEmployerCompanyLogoUploadPA.request, upload)
}
